import styled from "styled-components";

// Вертикальный стек с настраиваемым зазором — самый частый layout-примитив форм.
export const Stack = styled.div<{ $gap?: number }>`
    display: flex;
    flex-direction: column;
    gap: ${({ $gap }) => $gap ?? 16}px;
`;
